import Router from "next/router";

import type { Router as NavigationRouter } from "../router";
import { isNoopHref } from "./guards";

// The singleton rather than next/router's `useRouter()`, whose object changes
// on every route change. Callers list these methods in effect deps.
const router: NavigationRouter = {
  push: href => {
    if (!isNoopHref(href)) {
      void Router.push(href);
    }
  },
  replace: href => {
    if (!isNoopHref(href)) {
      void Router.replace(href);
    }
  },
  back: () => Router.back(),
};

export const useRouter = (): NavigationRouter => router;
